import { NavLink } from "react-router-dom";
import { Activity } from "lucide-react";
import { NAV_ITEMS } from "@/nav/navConfig";
import { useWorkspace } from "@/nav/WorkspaceContext";

export default function Sidebar() {
  const { isEnabled, openPicker } = useWorkspace();
  const visibleItems = NAV_ITEMS.filter((item) => isEnabled(item.path));

  return (
    <aside
      data-testid="sidebar"
      className="fixed left-0 top-0 h-screen flex flex-col"
      style={{
        width: 240,
        background: "#0F1923",
        borderRight: "1px solid var(--border-divider)",
        zIndex: 40,
      }}
    >
      {/* Brand */}
      <div className="px-5 py-5" style={{ borderBottom: "1px solid var(--border-divider)" }}>
        <div className="flex items-center gap-2.5">
          <div
            className="flex items-center justify-center rounded-md"
            style={{
              width: 32,
              height: 32,
              background: "linear-gradient(135deg, #00C2A8, #0EA5E9)",
              boxShadow: "0 0 20px rgba(0, 194, 168, 0.35)",
            }}
          >
            <Activity size={18} color="#0F1923" strokeWidth={2.5} />
          </div>
          <div>
            <div
              style={{
                fontFamily: "'JetBrains Mono', monospace",
                fontSize: 10,
                letterSpacing: "0.14em",
                color: "var(--text-muted)",
                textTransform: "uppercase",
              }}
            >
              Nurture&nbsp;OS
            </div>
            <div
              style={{
                fontFamily: "Inter, sans-serif",
                fontWeight: 700,
                fontSize: 14,
                letterSpacing: "-0.01em",
                color: "var(--text-primary)",
              }}
            >
              MQL Command
            </div>
          </div>
        </div>
      </div>

      {/* Nav */}
      <nav className="flex-1 overflow-y-auto py-4 px-3">
        <div
          data-testid="workspace-label"
          onClick={openPicker}
          className="workspace-label"
          style={{
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: 10,
            letterSpacing: "0.14em",
            textTransform: "uppercase",
            padding: "8px 10px",
            cursor: "pointer",
          }}
        >
          Workspace
        </div>
        <ul className="space-y-0.5">
          {visibleItems.map((item) => {
            const Icon = item.icon;
            return (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  end={item.path === "/"}
                  data-testid={item.testId}
                  className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
                >
                  <Icon className="nav-icon" strokeWidth={1.8} />
                  <span className="truncate">{item.label}</span>
                  {item.flagship && (
                    <span
                      className="ml-auto"
                      style={{
                        fontFamily: "'JetBrains Mono', monospace",
                        fontSize: 9,
                        padding: "2px 6px",
                        borderRadius: 4,
                        background: "rgba(245, 158, 11, 0.12)",
                        color: "#F59E0B",
                        letterSpacing: "0.08em",
                      }}
                    >
                      NEW
                    </span>
                  )}
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* Status footer */}
      <div className="px-4 py-4" style={{ borderTop: "1px solid var(--border-divider)" }}>
        <div className="flex items-center gap-2">
          <span className="pill-dot" style={{ background: "#22C55E", width: 8, height: 8, borderRadius: 999 }} />
          <div style={{ fontSize: 11, color: "var(--text-secondary)" }}>
            <div style={{ fontFamily: "'JetBrains Mono', monospace", color: "#22C55E", fontSize: 10 }}>
              SYSTEM · OPERATIONAL
            </div>
            <div style={{ color: "var(--text-muted)", fontSize: 10 }}>4 agents · 341 in sequence</div>
          </div>
        </div>
      </div>
    </aside>
  );
}
